import * as React from 'react';
import {Component, ReactElement} from 'react';
import {RouteComponentProps} from 'react-router';
import {trackOnce} from '../../../utils/tracker';
import {INSTITUTION} from '../../../utils/config';
import {
    AuthSignInForgotPassword as ForgotPassword,
} from '../sign-in-forgot-password/sign-in-forgot-password';
import {AuthSignInForm as SignInForm} from '../sign-in-form';
import {AuthContent as Content} from '../content';
import {AuthDivider as Divider} from '../divider';
import {AuthFooter as Footer} from '../footer';
import {AuthSocial as Social} from '../social/social';
import {AuthHeader as Header} from '../header';
import {AuthLabel as Label} from '../label';
import {AuthModal as Modal} from '../modal/modal';
import {IAuthSignInConnected, IAuthSignInActions} from './types';

export interface IAuthSignInProps extends RouteComponentProps<{}>,
  IAuthSignInConnected,
  IAuthSignInActions {}

export class AuthSignIn extends Component<IAuthSignInProps, {}> {
  public render(): ReactElement<any> {
    const {
      connectionRefusedError,
      socialError,
      isLoading,
      apiError,
      login,
    } = this.props;

    return (
      <Modal
        label={'Log In'}
        onClose={this.closeModal}
      >
        <Header>Log In</Header>
        <Content>
          {!INSTITUTION && (
            <>
              <Social
                externalError={socialError}
                onAuth={login}
              />
              <Divider>or</Divider>
            </>
          )}

          <SignInForm
            connectionRefusedError={connectionRefusedError}
            isLoading={isLoading}
            apiError={apiError}
            onSubmit={login}
          >
            <ForgotPassword />
          </SignInForm>
        </Content>

        <Footer>
          <Label>Don't have an account?</Label>
          <a href='https://www.tryexponent.com/practice?utm_source=pramp&utm_campaign=pramp_sign_in&utm_medium=referral' className='auth-link auth-link_purple'>Sign up on Exponent</a>
        </Footer>
      </Modal>
    );
  }

  public componentDidMount(): void {
    trackOnce('login');
  }

  private closeModal = (): void => {
    this.props.history.push('/');
  };
}
